<template>
  <ob-modal2 :show.sync="generatePopup" :backdrop="false"  width="700px">
    <template slot="modal-title" v-if="!generatePopupSuccessContent">
      Generate Report
    </template>
    <template slot="modal-body">
       <div v-if="generatePopupSuccessContent">
        <img class="center" style="height:150px;display: block; margin-left: auto; margin-right: auto;" :src="`${CDNIMAGESBASEURL}/commonimages/oblaptop-downloadobk.svg`" /> <br/>
      <p style="text-align:center;font-size:16px;">We have started preparing your {{ timesheetLabel.toLowerCase() }} report, it will take few minutes.</p>
      <p style="text-align:center;font-size:16px">We will send you the report to <b>{{this.loggedInUserObj.email}}</b> once it is generated.</p>
      </div>
      <div v-else>
      <div v-if="$route.name =='employer-timesheets'">
        <div class="row">
        <div class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Generate {{ timesheetLabel }} for</label>
          <span class="validation-star">*</span>
           <ob-select2  :options="generateForOptions"  :inModal="true" v-model.trim="selectGenerateFor"  :class="{ 'ob-vuelidate_input-error': $v.selectGenerateFor.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.selectGenerateFor.$dirty && !$v.selectGenerateFor.required">Please select</span>

            <div v-if="selectGenerateFor == 'AllEmployees'">
              <ob-checkbox style="margin-top: 10px;"  v-model="IncludeNotSubmittedRecords" :val="1"><span style="color: #000; font-size: 12px;">Include not submitted records</span></ob-checkbox>
            </div>
        </div>
        <div v-if="selectGenerateFor == 'IndividualEmployee'" class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Employee</label>
          <span class="validation-star">*</span>
           <ob-select2  v-if="showdropdown" :options="employeeList" :inModal="true" v-model.trim="selectedemployee" :class="{ 'ob-vuelidate_input-error': $v.selectedemployee.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.selectedemployee.$dirty && !$v.selectedemployee.requiredIf">Select Employee </span>
        </div>
        <div v-else-if="selectGenerateFor == 'Project'" class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Project</label>
          <span class="validation-star">*</span>
           <ob-select2  v-if="showdropdown" :options="ProjectListOptions" :inModal="true" v-model.trim="selectedproject" :class="{ 'ob-vuelidate_input-error': $v.selectedproject.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.selectedproject.$dirty && !$v.selectedproject.requiredIf">Select Project </span>
        </div>
        <div v-else-if="selectGenerateFor == 'End-Client'" class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select End-Client</label>
          <span class="validation-star">*</span>
           <ob-select2  v-if="showdropdown" :options="endClientListOptons" :inModal="true" v-model.trim="selectedEndClient" :class="{ 'ob-vuelidate_input-error': $v.selectedEndClient.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.selectedEndClient.$dirty && !$v.selectedEndClient.requiredIf">Select End-Client </span>
        </div>
        <div v-else-if="selectGenerateFor == 'Client'" class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Client</label>
          <span class="validation-star">*</span>
           <ob-select2  v-if="showdropdown" :options="clientListOptons" :inModal="true" v-model.trim="selectedClient" :class="{ 'ob-vuelidate_input-error': $v.selectedClient.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.selectedClient.$dirty && !$v.selectedClient.requiredIf">Select Client </span>
        </div>
        <!-- <div v-else-if="selectGenerateFor == 'Reporting Authority'" class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Reporting Authority</label>
          <span class="validation-star">*</span>
           <ob-select2  v-if="showdropdown" :options="reportingAuthtListOptons" :inModal="true" v-model.trim="selectedReportAuth" :class="{ 'ob-vuelidate_input-error': $v.selectedReportAuth.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.selectedReportAuth.$dirty && !$v.selectedReportAuth.requiredIf">Please select Reporting Authority </span>
        </div> -->
      </div>
      <hr class="dottedLine">
      <div class="row form-group">
        <div class="col-md-12">
          <label v-if="selectGenerateFor == 'IndividualEmployee'" style="font-size:13px;margin-bottom:-20px;">Enter a date range to generate a {{ timesheetLabel }} report. You can customize the report by selecting one of the options provided in the type of report.</label>
          <label v-else-if ="selectGenerateFor == 'AllEmployees'" style="font-size:13px;margin-bottom:-20px;">Select a date range to generate the {{ timesheetLabel }}/Expense report for all the employees, in Excel format.</label>
          <label v-else  style="font-size:13px;margin-bottom:-20px;">Select a date range to generate a {{ timesheetLabel }} report for {{selectGenerateFor}} in Excel format.</label>
        </div>
      </div>
    </div>

    <div v-if="$route.name !='employer-timesheets'" class="row form-group">
          <div class="col-md-12 pL0">
            <label style="font-size:13px;margin-left:16px;px;margin-bottom:-20px;">Enter a date range to generate a {{ timesheetLabel }} report. You can customize the report by selecting one of the options provided below.</label>
          </div>
        </div>
    <div class="row" >
        <div class="col-md-12 pL0" style="margin-top:10px;">
         <div class="col-md-6" style="margin-bottom:20px;">
            <label>Select Range</label><span class="validation-star">*</span>
            <div class="row">
              <div class="col-md-6 pR0">
              <ob-date-time-picker :key="keyValueUpdate" v-if="generatePopup" ref="dateFrom" id="dateFrom" :options="options" :inputvalue="dateFrom" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange"  v-model.trim="dateFrom"  :class="{ 'ob-vuelidate_input-error': $v.dateFrom.$error }"></ob-date-time-picker>
              <span class="ob-vuelidate_error-msg" v-if="$v.dateFrom.$dirty && !$v.dateFrom.required">Select From Date</span>
          </div>
          <div class="col-md-6">
           <ob-date-time-picker :key="keyValueUpdate" v-if="generatePopup" ref="dateTo" id="dateTo" :options="options" :inputvalue="dateTo" @updated="(v) => this.dateTo = v" v-model.trim="dateTo"  :class="{ 'ob-vuelidate_input-error': $v.dateTo.$error }" ></ob-date-time-picker>
              <span class="ob-vuelidate_error-msg" v-if="$v.dateTo.$dirty && !$v.dateTo.required">Select To Date</span>
          </div>
        </div>
      </div>
      <!-- <div v-if="$route.name !='employer-timesheets'">
        <div class="col-md-12">
          <ob-radio name="reportOptions" v-model.trim="ReportType" val="TimeSheetReport">Timesheet Report</ob-radio>
          <ob-radio name="reportOptions" v-model="ReportType" val="ExportAsExcel">Export To Excel </ob-radio>
        </div>
      </div> -->
      <div v-if="selectGenerateFor == 'IndividualEmployee'  || selectGenerateFor == 'AllEmployees' || $route.name =='my-timesheets' " class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Type of Report</label>
          <span class="validation-star">*</span>
           <ob-select2 v-if="showindividaulOptions" :options="computedTypeOfReportOptions()"  :inModal="true" v-model.trim="ReportType"  :class="{ 'ob-vuelidate_input-error': $v.ReportType.$error }"></ob-select2>
           <ob-select2 v-else-if="showExcelOptions" :options="computedTypeOfReportOptionsForAll()"  :inModal="true" v-model.trim="ReportType"  :class="{ 'ob-vuelidate_input-error': $v.ReportType.$error }"></ob-select2>
          <span class="ob-vuelidate_error-msg" v-if="$v.ReportType.$dirty && !$v.ReportType.requiredIf">Select Reporting </span>
        </div>
      </div>
    </div>

        <hr class="dottedLine">
<div class="row form-group">
        <div class="col-md-12">        
          <label style="font-size:13px;">How would you like to generate report ?</label>
          <!-- <label style="font-size:12px;font-weight: 600; color: #4688D5;">
            Note:The task details include the task title, description, created date, duration, comments, and employer or supervisor          </label> -->

          <div class="form-group" style="display: flex;flex-direction: column;">
              <div class="col pL0">
                  <div class="radio-inline" style="padding-left:0px;">
                      <ob-radio v-model="isCombinedReport" :val="true"><div><div style="font-weight: bold;">Combined  Report </div><p>Select this option to generate a combined report that totals all weekly time logs into a single monthly summary.</p></div></ob-radio>
                  </div>
              </div>
              <div class="col  pL0">
                  <div class="radio-inline" style="padding-left:0px;">
                      <ob-radio  v-model="isCombinedReport" :val="false"><div><div style="font-weight: bold;">Detailed  Report</div><p>Select this option to generate a detailed report showing individual data separately, along with task descriptions and details.</p></div></ob-radio>
                  </div>
              </div>
          </div>

        </div>
      </div>
  </div>
    <template  v-if="(ReportType == 'TimeSheetReport' || ReportType == 'TimeSheetExpenseReport') && isCombinedReport === false">
      <hr class="dottedLine">
      <div class="row form-group">
        <div class="col-md-12">
          <label style="font-size:13px;">Would you like to include task details in {{ timesheetLabel.toLowerCase() }} report? </label>
          <label style="font-size:12px;font-weight: 600; color: #4688D5;">
            Note:The task details include the task title, description, created date, duration, comments, and employer or supervisor          </label>

          <div class="form-group">
              <div class="col-md-1 pL0">
                  <div class="radio-inline" style="padding-left:0px;">
                      <ob-radio name="IsIncludeTaskDescription" v-model="IncludeTaskDescription" :val="true">Yes</ob-radio>
                  </div>
              </div>
              <div class="col-md-1  pL0">
                  <div class="radio-inline">
                      <ob-radio name="IsIncludeTaskDescription" v-model="IncludeTaskDescription" :val="false">No</ob-radio>
                  </div>
              </div>
          </div>

        </div>
      </div>
    </template>
      <!-- <div v-if="$route.name !='employer-timesheets'">
        <div class="row form-group">
          <div class="col-md-12">
            <label style="font-size:13px;margin-left:16px;px;margin-bottom:-20px;">Enter a date range to generate a Timesheet report. You can customize the report by selecting one of the options provided below.</label>
          </div>
        </div>
      </div> -->
      <!-- <div v-else>
        <div class="row form-group">
          <div class="col-md-12">
            <label v-if="EmpType =='IndividualEmployee'" style="font-size:13px;margin-left:16px;px;margin-bottom:-20px;">Please select an employee and the corresponding date range to generate a Timesheet report. You can customize the report by selecting one of the options provided below.</label>
            <label v-else style="font-size:13px;margin-left:16px;px;margin-bottom:-20px;">Please select the date range to generate the Timesheet report for all the employees, in Excel format.</label>
          </div>
          <div style="padding-top:15px" class="col-md-12">
          <div class="col-md-3 pR0">
            <ob-radio name="options1" v-model="EmpType" val="IndividualEmployee">Individual Employee</ob-radio>
          </div>
          <div class="col-md-2 pL0 pR0">
            <ob-radio  name="options1" v-model="EmpType" val="AllEmployees">All Employees</ob-radio>
          </div>
          <div class="col-md-1 pL0 pR0">
            <ob-radio name="options1" v-model="EmpType" val="Project">Project</ob-radio>
          </div>
          <div style="padding-left:35px" class="col-md-2 pR0">
            <ob-radio name="options1" v-model="EmpType" val="EndClient">End-Client</ob-radio>
          </div>
          <div class="col-md-1 ">
            <ob-radio name="options1" v-model="EmpType" val="Client">Client</ob-radio>
          </div>
          <div style="padding-left:35px" class="col-md-3 pR0">
            <ob-radio name="options1" v-model="EmpType" val="ReportingAuthority">Reporting Authority</ob-radio>
          </div>
        </div>
        </div>
      </div> -->
      <!-- <div  v-if="$route.name=='employer-timesheets'">
        <div v-if="EmpType == 'IndividualEmployee'" class="col-md-12 pL0"  style="border-bottom: 2px dashed #d4cccc;">
          <div class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
            <label>Select Employee</label>
            <span class="validation-star">*</span>
            <ob-select2  v-if="showdropdown" :options="employeeList" :inModal="true" v-model.trim="selectedemployee" :class="{ 'ob-vuelidate_input-error': $v.selectedemployee.$error }"></ob-select2>
            <span class="ob-vuelidate_error-msg" v-if="$v.selectedemployee.$dirty && !$v.selectedemployee.requiredIf">Please select Employee </span>
          </div>
        </div>
        <div v-else-if="EmpType == 'Project'" class="col-md-12 pL0"  style="border-bottom: 2px dashed #d4cccc;">
        <div class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Project</label>
         <span class="validation-star">*</span>
          <ob-select2  v-if="showdropdown" :options="projectList" :inModal="true" v-model.trim="selectedproject" :class="{ 'ob-vuelidate_input-error': $v.selectedproject.$error }"></ob-select2>
         <span class="ob-vuelidate_error-msg" v-if="$v.selectedproject.$dirty && !$v.selectedproject.required">Please select Project</span>
        </div>
       </div>
       <div v-else-if="EmpType == 'EndClient'" class="col-md-12 pL0"  style="border-bottom: 2px dashed #d4cccc;">
        <div class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select End-Client</label>
         <span class="validation-star">*</span>
          <ob-select2  v-if="showdropdown" :options="endClientList" :inModal="true" v-model.trim="selectedEndClient" :class="{ 'ob-vuelidate_input-error': $v.selectedEndClient.$error }"></ob-select2>
         <span class="ob-vuelidate_error-msg" v-if="$v.selectedEndClient.$dirty && !$v.selectedEndClient.required">Please select End-Client</span>
        </div>
       </div>
       <div v-else-if="EmpType == 'Client'" class="col-md-12 pL0"  style="border-bottom: 2px dashed #d4cccc;">
        <div class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Client</label>
         <span class="validation-star">*</span>
          <ob-select2  v-if="showdropdown" :options="clientList" :inModal="true" v-model.trim="selectedClient" :class="{ 'ob-vuelidate_input-error': $v.selectedClient.$error }"></ob-select2>
         <span class="ob-vuelidate_error-msg" v-if="$v.selectedClient.$dirty && !$v.selectedClient.required">Please select Client</span>
        </div>
       </div>
       <div v-else-if="EmpType == 'ReportingAuthority'" class="col-md-12 pL0"  style="border-bottom: 2px dashed #d4cccc;">
        <div class="col-md-6" style="margin-bottom: 10px;padding-left:16px;">
         <label>Select Reporting Authority</label>
         <span class="validation-star">*</span>
          <ob-select2  v-if="showdropdown" :options="reportingAuthList" :inModal="true" v-model.trim="selectedReportAuth" :class="{ 'ob-vuelidate_input-error': $v.selectedReportAuth.$error }"></ob-select2>
         <span class="ob-vuelidate_error-msg" v-if="$v.selectedReportAuth.$dirty && !$v.selectedReportAuth.required">Please select Client</span>
        </div>
       </div>
      </div> -->
      <!-- <div class="row" >
        <div class="col-md-12" style="margin-top:10px;">
          <div class="col-md-6" style="margin-bottom:20px;">
            <label>Select Range</label><span class="validation-star">*</span>
            <div class="row">
              <div class="col-md-6">
                <ob-date-time-picker :key="keyValueUpdate" v-if="generatePopup" ref="dateFrom" id="dateFrom" :options="options4" :inputvalue="dateFrom" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange" v-model.trim="dateFrom" :class="{ 'ob-vuelidate_input-error': $v.dateFrom.$error }"></ob-date-time-picker>
                <span class="ob-vuelidate_error-msg" v-if="$v.dateFrom.$dirty && !$v.dateFrom.required">Please select From Date</span>
              </div>
              <div class="col-md-6">
                <ob-date-time-picker :key="keyValueUpdate" v-if="generatePopup" ref="dateTo" id="dateTo" :options="options4" :inputvalue="dateTo" @updated="(v) => this.dateTo = v" v-model.trim="dateTo" :class="{ 'ob-vuelidate_input-error': $v.dateTo.$error }" ></ob-date-time-picker>
                <span class="ob-vuelidate_error-msg" v-if="$v.dateTo.$dirty && !$v.dateTo.required">Please select To Date</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="EmpType == 'IndividualEmployee'" class="row form-group">
        <div class="col-md-12" style="padding-left:30px;">
          <ob-radio name="reportOptions" v-model.trim="ReportType" val="TimeSheetReport">Timesheet Report</ob-radio>
          <ob-radio name="reportOptions" v-model="ReportType" val="TimeSheetReportTasks">Timesheet Report and Task Details</ob-radio>
          <ob-radio name="reportOptions" v-model="ReportType" val="TimeSheetReportTasksEvaluations">Timesheet Report, Task Details and Evaluations</ob-radio>
          <ob-radio name="reportOptions" v-model="ReportType" val="TimeSheetReportTasksEvaluationsComments">Timesheet Report, Task Details and Evaluations and Comments</ob-radio>
          <ob-radio name="reportOptions" v-model="ReportType" val="TimeSheetReportTasksEvaluationsCommentsWithDates">Timesheet Report, Task Details and Evaluations and Comments with Dates</ob-radio>
          <ob-radio name="reportOptions" v-model="ReportType" val="ExportAsExcel">Export To Excel </ob-radio>
        </div>
      </div> -->
      </div>
    </template>
    <template slot="modal-footer">
       <ob-button  v-if="!generatePopupSuccessContent" type="secondary" @click="cancel()">Cancel</ob-button>
      <ob-button  v-if="!generatePopupSuccessContent" @click="generate()"> Generate </ob-button>
      <ob-button  v-if="generatePopupSuccessContent" type="secondary" @click="cancel()">Ok, Got it</ob-button>
    </template>
  </ob-modal2>
</template>

<script>
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
export default {
  props:["show", "EmployeeId"],
  data()
  {
    return {
      IncludeTaskDescription:'',
      IncludeNotSubmittedRecords:false,
      showExcelOptions : false,
      showindividaulOptions : false,
      keyValueUpdate:0,
      generatePopupSuccessContent:false,
      //showReportOptions:true,
      ReportType: 'ExportAsExcel',
      EmpList:[],
      ProjectList:[],
      endClientList:[],
      clientList :[],
      reportingAuthList:[],
      selectGenerateFor:'',
      selectedproject :'',
      selectedEndClient:'',
      selectedClient:'',
      // selectedReportAuth:'',
      selectedemployee:'',
      showdropdown : false,
      dateFrom:'',
      dateTo:'',
      isLoading:false,
      generatePopup:false,
      options: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        minDate:moment('01/01/1970').format('MM/DD/YYYY'),
        maxDate: moment().add(1, 'M'),
      },
      generateForOptions:{
        placeholder: {
        id: "-1",
        text: "Please Select"
        },
        data: [
          { id: "IndividualEmployee", text: "Individual Employee" },
          { id: "AllEmployees", text: "All Employees" },
          { id: "Project", text: "Project" },
          { id: "End-Client", text: "End-Client" },
          { id: "Client", text: "Client" },
          // { id: "Reporting Authority", text: "Reporting Authority" },
        ]
      },
      typeOfReportOptions:{
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      typeOfReportOptionsForAll:{
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      employeeList: {
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      ProjectListOptions:{
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      endClientListOptons:{
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      clientListOptons:{
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      reportingAuthtListOptons:{
        placeholder: {
          id: "-1",
          text: "Please Select"
          },
        data: []
      },
      isCombinedReport:""
    }
  },

  methods:{
    computedTypeOfReportOptions() {
      const label = this.timesheetLabel || 'Timesheets';
      return {
        placeholder: {
          id: "-1",
          text: "Please Select"
        },
        data: [
          { id: "ExportAsExcel", text: `Export to Excel (${label} Report)` },
          { id: "TimeSheetReport", text: `${label} Report` },
          { id: "ExpenseReport", text: "Expense Report" },
          { id: "ExpenseExcel", text: "Export to Excel (Expense Report)" },
          { id: "TimeSheetExpenseReport", text: `Combined ${label} and Expense Report` },
        ]
      };
    },
    computedTypeOfReportOptionsForAll() {
      const label = this.timesheetLabel || 'Timesheets';
      return {
        placeholder: {
          id: "-1",
          text: "Please Select"
        },
        data: [
          { id: "ExportAsExcel", text: `Export to Excel (${label} Report)` },
          { id: "ExpenseExcel", text: "Export to Excel (Expense Report)" },
        ]
      };
    },
    resetValues(){
      this.IncludeTaskDescription = '',
      this.IncludeNotSubmittedRecords = false,
      this.selectedemployee = '',
      this.selectedproject ='',
      this.selectedEndClient = '',
      this.selectedClient='',
      // this.selectedReportAuth ='',
      this.dateFrom = '',
      this.dateTo = '',
      this.$v.dateFrom.$reset(),
      this.$v.dateTo.$reset(),
      this.$v.selectedemployee.$reset()
      this.$v.selectedproject.$reset()
      this.$v.selectedEndClient.$reset()
      this.$v.selectedClient.$reset()
      // this.$v.selectedReportAuth.$reset()
    },
    onFromDateChange(e) {
      setTimeout(() => {
        let d1 = e.date.format('MM/DD/YYYY')
        this.$refs.dateTo.data.minDate(d1)
      }, 100)
    },
     cancel(){
      this.generatePopup = false
      this.generatePopupSuccessContent = false
      this.isCombinedReport = ""
      //this.EmpType = 'IndividualEmployee'
    },
    successContent(){
      this.generatePopupSuccessContent=false
    },
    generate()
    {

      this.$v.selectedemployee.$touch();
      this.$v.selectedproject.$touch();
      this.$v.selectedEndClient.$touch();
      this.$v.selectedClient.$touch();
      // this.$v.selectedReportAuth.$touch();
      this.$v.dateFrom.$touch();
      this.$v.dateTo.$touch();
      if(this.selectGenerateFor == "IndividualEmployee" && this.ReportType != "ExportAsExcel" && this.ReportType != "ExpenseExcel" ) {
      if(this.$v.dateFrom.$invalid == false && this.$v.dateTo.$invalid == false && this.$v.selectedemployee.$invalid == false){
        this.$loading({ 'loadingText': 'Loading...' })
        var empId ;
        if(this.$route.name !='employer-timesheets')
        {
          empId = this.EmployeeId
        }
        else{
          empId = this.selectedemployee
        }
        if(this.isCombinedReport === true){
            this.ReportType = "TimesheetCombinedReport"
        }
      var Obj = {
         "FromDate": this.dateFrom,
          "ToDate": this.dateTo,
          "EmployeeId": empId,
          "ReportType":this.ReportType,
          "IsCustomReport": true,
          "empOrgId":this.loggedInUserObj.orgId,
          "IncludeTaskDescription":this.IncludeTaskDescription
         // "ConnectionId" :$.connection.notificationHub.connection.id
      }
    ajax.put(`TimeSheets/CustomReport`, Obj , res => {
      if(res.data.State == true) {

       // this.cancel();
         if(res.data.Message == 'Reports are Generating')
        {
            this.generatePopupSuccessContent=true
             let report = ''
            if(this.ReportType == 'ExportAsExcel'){
              report = 'Timesheet Excel'
            }
            else if(this.ReportType == 'TimeSheetReport'){
              report = 'Timesheet'
            }
            else if(this.ReportType == 'ExpenseReport'){
              report = 'Expense'
            }
            else if(this.ReportType == 'TimeSheetExpenseReport'){
              report = 'TimesheetExpense'
            }
            else if(this.ReportType == 'ExpenseExcel'){
              report = 'Expense Excel'
            }
            else if(this.ReportType == 'TimeSheetExpenseExcel'){
              report = 'TimesheetExpense Excel'
            }
            else
            {
                report = 'Timesheet'
            }

            // events.fire("IsTimesheetInProgress",true);
            // this.$parent.$refs.draggablTimesheetReportProgress.reportType = report;
            // this.$parent.$refs.draggablTimesheetReportProgress.showTimesheetDraggablePopUp = true;
        }
        else
        {
            window.open(res.data.ReportUrl, "_blank");
        }
        this.$loading({}).close();
      }else if(res.data.State == false){
        this.$loading({}).close();
        this.$message({
          type: 'error',
          message: res.data.Message,
          duration : 1500
        })
        }
      })
    }
   }
  else{
    if(this.$v.dateFrom.$invalid == false && this.$v.dateTo.$invalid == false && this.$v.selectedemployee.$invalid == false&& this.$v.selectedproject.$invalid == false
       && this.$v.selectedEndClient.$invalid == false &&  this.$v.selectedClient.$invalid == false ){
      let isSupervisor;
      let _empId ;
      let obj;
     if(this.selectGenerateFor == "IndividualEmployee"  && (this.ReportType == "ExportAsExcel"  || this.ReportType == "ExpenseExcel" )&& this.$route.name=='employer-timesheets'){
           obj = {
            "FromDate":this.dateFrom,
            "ToDate":this.dateTo,
            "EmpIdList":null,
            "EmpId" : this.selectedemployee,
            "OrgId":this.loggedInUserObj.orgId,
            "IsSupervisor":false,
            "ProjectId":'',
            "EndClient":'',
            "Client":'',
            "ReportingAuthId":'',
            "ReportType":this.ReportType,
          }
      }
      else if(this.selectGenerateFor =='Project'){
             obj = {
            "FromDate":this.dateFrom,
            "ToDate":this.dateTo,
            "EmpIdList":null,
            "EmpId" : '',
            "OrgId":this.loggedInUserObj.orgId,
            "IsSupervisor":this.loggedInUserObj.IsSupervisor,
            "ProjectId":this.selectedproject,
            "EndClient":'',
            "Client":'',
            "ReportingAuthId":''
          }
      }
       else if(this.selectGenerateFor =='End-Client'){
             obj = {
            "FromDate":this.dateFrom,
            "ToDate":this.dateTo,
            "EmpIdList":null,
            "EmpId" : '',
            "OrgId":this.loggedInUserObj.orgId,
            "IsSupervisor":this.loggedInUserObj.IsSupervisor,
            "ProjectId":'',
            "EndClient":this.selectedEndClient,
            "Client":'',
            "ReportingAuthId":''
          }
      }
       else if(this.selectGenerateFor =='Client'){
             obj = {
            "FromDate":this.dateFrom,
            "ToDate":this.dateTo,
            "EmpIdList":null,
            "EmpId" : '',
            "OrgId":this.loggedInUserObj.orgId,
            "IsSupervisor":this.loggedInUserObj.IsSupervisor,
            "ProjectId":'',
            "EndClient":'',
            "Client":this.selectedClient,
            "ReportingAuthId":''
          }
      }
      else if(this.$route.name =='my-timesheets'){
            obj = {
            "FromDate":this.dateFrom,
            "ToDate":this.dateTo,
            "EmpIdList":null,
            "EmpId" : this.loggedInUserObj.empId,
            "OrgId":this.loggedInUserObj.orgId,
            "IsSupervisor":this.loggedInUserObj.IsSupervisor,
            "ProjectId":'',
            "EndClient":'',
            "Client":'',
            "ReportingAuthId":'',
            "ReportType":this.ReportType,
          }
      }
      else{
          obj = {
            "FromDate":this.dateFrom,
            "ToDate":this.dateTo,
            "EmpIdList":null,
            "EmpId" : '',
            "OrgId":this.loggedInUserObj.orgId,
            "IsSupervisor":true,
            "ProjectId":'',
            "EndClient":'',
            "Client":'',
            "ReportingAuthId": this.loggedInUserObj.empId ,
            "ReportType":this.ReportType,
            "IncludeNotSubmittedRecords":this.IncludeNotSubmittedRecords

          }
      }
     // obj["ConnectionId"]  = $.connection.notificationHub.connection.id

      let endPoint ;
          if(this.ReportType == 'ExpenseExcel'){
              endPoint = "TimeSheets/ExpenseExport/Excel"
          }
          else{
            endPoint = "TimeSheets/GenerateExcelReport"
          }
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.put(endPoint, obj , res => {
      if(res.data.State == true) {
      //this.cancel();
         if(res.data.Message == 'Timesheet Excel Report Generating' || res.data.Message == 'Expense Report Generating')
          {
 this.generatePopupSuccessContent=true
            let report = ''
            if(this.ReportType == 'ExportAsExcel'){
              report = 'Timesheet Excel'
            }
            else if(this.ReportType == 'TimeSheetReport'){
              report = 'Timesheet'
            }
            else if(this.ReportType == 'ExpenseReport'){
              report = 'Expense'
            }
            else if(this.ReportType == 'ExpenseExcel'){
              report = 'Expense Excel'
            }
            else
            {
                report = 'Timesheet'
            }

            // events.fire("IsTimesheetInProgress",true);
            // this.$parent.$refs.draggablTimesheetReportProgress.reportType = report;
            // this.$parent.$refs.draggablTimesheetReportProgress.showTimesheetDraggablePopUp = true;
          }
          else
          {
             window.open(res.data.ReportUrl, "_blank");
          }
      this.$loading({}).close();
      }else if(res.data.State == false){
        this.$loading({}).close();
        this.$message({
          type: 'error',
          message: res.data.Message,
          duration : 1500
        })
        }
      })
   }
  }
 },

  getEmployeeList()
  {
    this.$loading({loadingText: 'Please wait...'});
    ajax.get(`/Supervisor/GetReportingEmployeeList?empId=${this.loggedInUserObj.empId}`, {}, (res) => {
      if(res.data.resultList.length > 0)
      {
        this.EmpList = res.data.resultList;
        this.employeeList.data = __.map(res.data.resultList, (t) => {
        return {
          'id': t.EmployeeId,
          'text': t.Name
        }
      })
      this.setEmployeeOptions()
        }
      })
    },
     getProjectList(){
      ajax.get(`/TimeSheets/ProjectDetails`, {}, (res) => {
      if(res.data.State == true){
      this.projectList = res.data.ProjectDetails
          }
        })
    },
    setEmployeeOptions(){
      //this.$loading({loadingText: 'Please wait...'});
       this.showdropdown = false
       this.employeeList.data = [];
        setTimeout(() => {
       this.employeeList.data = __.map(this.EmpList, (t) => {
        return {
          'id': t.EmployeeId,
          'text': t.Name
        }})
              this.showdropdown = true;
             this.$loading({}).close()

      },10)
     },
     setProjectOptions()
     {
       this.showdropdown = false
       this.ProjectListOptions.data = [];
       this.employeeList.data = [];
       let projectsList = this.getUnique(this.projectList,"JobId")
        setTimeout(() => {
       this.ProjectListOptions.data = __.map(projectsList, (t) => {
        return {
          'id': t.JobId,
          'text': t.JobName
        }})
             this.showdropdown = true;

      }, 10)

     },
     setEndClientOptions()
     {
       this.showdropdown = false
       this.endClientListOptons.data = [];
       let filteredEndClient = this.projectList.filter(item => item.EndClientOrganizationName != '');
       let endCleintList = this.getUnique(filteredEndClient,"EndClientOrganizationName")
        setTimeout(() => {
       this.endClientListOptons.data = __.map(endCleintList, (t) => {
        return {
          'id': t.EndClientOrganizationName,
          'text': t.EndClientOrganizationName
        }})
             this.showdropdown = true;

      }, 10)

     },
     setClientOptions(){
        this.showdropdown = false
       this.clientListOptons.data = [];
       let filteredClientList = this.projectList.filter(item => item.ClientOrganizationId != '');
       let uniqueClientList = this.getUnique(filteredClientList,"ClientOrganizationId")
        setTimeout(() => {
       this.clientListOptons.data = __.map(uniqueClientList, (t) => {
        return {
          'id': t.ClientOrganizationId,
          'text': t.ClientOrganizationName
        }})
             this.showdropdown = true;

      }, 10)
     },
     getUnique(arr, comp) {
      const unique = arr
          .map(e => e[comp])

          // store the keys of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)

          // eliminate the dead keys & store unique objects
          .filter(e => arr[e]).map(e => arr[e]);
      return unique;
      },
    //  setReportingAuthOptions(){
    //    this.showdropdown = false
    //    this.reportingAuthtListOptons.data = [];
    //     setTimeout(() => {
    //     this.reportingAuthtListOptons.data = __.map(this.reportingAuthList, (t) => {
    //     return {
    //       'id': t.id,
    //       'text': t.text
    //     }})
    //          this.showdropdown = true;

    //   }, 10)
    //  }
  },

  created()
  {
    this.generatePopup = this.show
    //this.getEmployeeList()
    this.selectGenerateFor = 'IndividualEmployee',
    this.ReportType = 'ExportAsExcel',
    this.resetValues();
  },
  validations()
  {
    return{
       "selectedemployee":{
        requiredIf : requiredIf(()=>{
          if(this.selectGenerateFor == 'IndividualEmployee' && this.$route.name !='my-timesheets' ){
            return true
          }else{
            return false
          }
        })

      },
      "selectGenerateFor":{
          required
      },
      "selectedproject":{
          // required
          requiredIf : requiredIf(()=>{
          if(this.selectGenerateFor == 'Project'){
            return true
          }else{
            return false
          }
        })
      },
      "selectedEndClient":{
          requiredIf : requiredIf(()=>{
          if(this.selectGenerateFor == 'End-Client'){
            return true
          }else{
            return false
          }
        })
      },
      "selectedClient":{
           requiredIf : requiredIf(()=>{
          if(this.selectGenerateFor == 'Client'){
            return true
          }else{
            return false
          }
        })
      },
      "dateFrom":{
        required
      },
      "dateTo":{
        required
      },
      "ReportType":{
        required
      }
    }
  },
    watch: {
      selectGenerateFor(val){
          if(val == 'Project'){
            this.setProjectOptions()
            this.ReportType = "ExportAsExcel"
            this.keyValueUpdate++;
            this.resetValues()
          }
          else if(val == "IndividualEmployee"){
          this.showindividaulOptions = false
          this.showExcelOptions = false
          this.setEmployeeOptions()
          this.ReportType = "TimeSheetReport"
          this.keyValueUpdate++;
          this.resetValues()
          setTimeout(() => {
          this.showindividaulOptions = true
           }, 10)
         }
         else if(val == "End-Client"){
          this.setEndClientOptions()
          this.ReportType = "ExportAsExcel"
          this.keyValueUpdate++;
          this.resetValues()
         }
         else if(val == "Client"){
          this.setClientOptions()
          this.ReportType = "ExportAsExcel"
          this.keyValueUpdate++;
          this.resetValues()
         }
        //  else if(val =="Reporting Authority"){
        //   this.setReportingAuthOptions()
        //   this.ReportType = "ExportAsExcel"
        //   this.keyValueUpdate++;
        //   this.resetValues()
        //  }
         else {
          this.showindividaulOptions = false;
          this.showExcelOptions = false;
          this.ReportType = "ExportAsExcel"
          this.keyValueUpdate++;
          this.resetValues()
          setTimeout(() => {
          this.showExcelOptions = true;
           }, 10)
         }
      },
      show(val) {
        if(val){
          this.ReportType ="TimeSheetReport"
          this.selectGenerateFor= 'IndividualEmployee',
          this.resetValues();
          this.generatePopup = val;
          if(this.$route.name == 'employer-timesheets' && val)
          {
            this.getEmployeeList()
            this.getProjectList()
          }
        }
      },
      generatePopup(val) {
        this.$emit('update:show', val);
      },
    }
  }
</script>
<style>
 .validation-star{
    color: #F31D1D;
  }
  .dottedLine{
    border-top: 2px dashed #DFDFDF;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/GenerateReport.vue